  <div class="alert-default clearfix error" role="alert">
     {{>icon uuid='audio-starter__icon' icon='fas fa-exclamation-circle' classes="audio-starter__icon"}}
     <div class="alert__container">
       <p class="alert__container__title">{{t 'audioFailedAlertTitle'}}</p>
       <p class="alert__container__message">{{t 'audioFailedAlertBody'}}</p>
       <button class="btn btn-compact btn-overlay" id="start_audio">{{t 'startAudioButton'}}</button>
     </div>
     <button type="button" class="alert__closeBtn close">
       <span aria-hidden="true">&times;</span>
     </button>
  </div>
